/**
 * Previous / next client on a client's profile, stepping through the list it was opened from.
 * ← / → do the same while focus is outside a form field.
 */
import { useEffect } from 'react';

export interface ClientNav {
  index: number;
  total: number;
  go: (index: number) => void;
}

const btn = 'h-8 rounded-md border border-line-strong px-3 text-xs font-semibold text-fg disabled:opacity-50';

export function ClientNavBar({ nav }: { nav: ClientNav }) {
  const { index, total, go } = nav;
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
      if ((e.target as HTMLElement | null)?.closest('input,textarea,select,[contenteditable="true"]')) return;
      if (e.key === 'ArrowLeft' && index > 0) go(index - 1);
      else if (e.key === 'ArrowRight' && index < total - 1) go(index + 1);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [index, total, go]);
  return (
    <div className="flex items-center gap-2 text-xs">
      <button type="button" className={btn} disabled={index <= 0} onClick={() => go(index - 1)} title="Previous client (←)">
        ← Previous client
      </button>
      <span className="num text-muted">
        {index + 1} of {total}
      </span>
      <button type="button" className={btn} disabled={index >= total - 1} onClick={() => go(index + 1)} title="Next client (→)">
        Next client →
      </button>
    </div>
  );
}
